/* lk-global.js — comportamento global do tema LK.
   Extraído de layout/theme.liquid em 2026-07-26 para virar asset cacheável.
   NÃO mover para cá o bloco de captura de intenção de carrinho: ele faz
   monkey-patch de window.fetch e precisa ser instalado durante o parse. */

/* ── wishlist (era layout/theme.liquid L984) ── */
/* LK Wishlist — localStorage (works without Swym) */
    (function(){ try {
      var KEY = 'lk_wishlist';
      function getList() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e) { return []; } }
      function setList(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch(e) {} updateCounter(l); }
      function updateCounter(l) {
        if (!l) l = getList();
        var badge = document.getElementById('lk-wish-count');
        if (badge) {
          if (l.length > 0) { badge.textContent = l.length; badge.style.display = 'flex'; }
          else { badge.style.display = 'none'; }
        }
      }

      function initHearts(btns) {
        btns = btns || document.querySelectorAll('.pc__wishlist');
        var list;
        btns.forEach(function(btn) {
          if (btn.dataset.lkInit) return;
          btn.dataset.lkInit = '1';
          var pid = btn.dataset.productId;
          if (!pid) return;
          pid = String(pid).replace(/"/g, '');

          /* Set initial state */
          if (!list) list = getList();
          if (list.indexOf(pid) > -1) {
            btn.classList.add('swym-added');
            var outline = btn.querySelector('.pc__heart--outline');
            var filled = btn.querySelector('.pc__heart--filled');
            if (outline) outline.style.display = 'none';
            if (filled) filled.style.display = '';
          }

          /* Only the hybrid capture handler (lk-swym-hybrid-v1.js) talks to Swym; local state stays immediate. */
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var self = this;
            var isAdded = self.classList.contains('swym-added');

            if (isAdded) {
              self.classList.remove('swym-added');
              var o=self.querySelector('.pc__heart--outline'); if(o) o.style.display='';
              var f=self.querySelector('.pc__heart--filled'); if(f) f.style.display='none';
              var cl = getList(); var ci = cl.indexOf(pid); if(ci>-1) cl.splice(ci,1); setList(cl);
            } else {
              self.classList.add('swym-added');
              var o2=self.querySelector('.pc__heart--outline'); if(o2) o2.style.display='none';
              var f2=self.querySelector('.pc__heart--filled'); if(f2) f2.style.display='';
              var cl = getList(); if(cl.indexOf(pid)===-1) cl.push(pid); setList(cl);
            }
          });
        });
      }

      /* Update counter on load */
      updateCounter();
      /* Init on DOM ready */
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() { initHearts(); });
      } else {
        initHearts();
      }
      /* Re-init after dynamic content (AJAX load more, section render) */
      document.addEventListener('shopify:section:load', function() { initHearts(); });
      var mo = new MutationObserver(function(muts) {
        var btns = new Set();
        function collectHeart(btn) {
          if (!btn.dataset.lkInit) btns.add(btn);
        }
        muts.forEach(function(m) {
          m.addedNodes.forEach(function(node) {
            if (node.nodeType !== 1 || !node.isConnected) return;
            if (node.matches('.pc__wishlist')) collectHeart(node);
            node.querySelectorAll('.pc__wishlist').forEach(collectHeart);
          });
        });
        /* MutationObserver already batches insertions before the next interaction. */
        if (btns.size) initHearts(Array.from(btns));
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch(err) { console.warn('LK Wishlist error:', err); } })();

/* ── header-sticky: removido em 2026-09-22 (theme-performance-wave-20260922).
   O único controlador de scroll do header mobile é o de sections/lk-header.liquid
   (__lkMobileHeaderScrollUpV2, ≤989px, classes lk-scroll-*). O daqui (≤749px,
   is-hidden/is-force-visible) escutava o mesmo scroll e escondia o header ainda
   sticky entre 64 e 88px. Ver docs/theme-quality/2026-07-26-conflito-dois-headers.md */

/* ── quick-add (era layout/theme.liquid L1126) ── */
/* Quick Add to Cart — unified handler (delegated click, non-blocking) */
    (window.requestIdleCallback || function(cb){ return setTimeout(cb, 1); })(function() {
      if (window.__lkQuickAddUnifiedV1) return;
      window.__lkQuickAddUnifiedV1 = true;
      document.addEventListener('click', function(e) {
        /* lk-quickadd-hotfix-v1.js (carregado por ScriptTag, fora do tema) registra
           um handler para os mesmos seletores, com flag de guarda própria. Com os dois
           ativos, um clique disparava dois /cart/add.js. O hotfix é superconjunto deste
           handler: além do add, ele dispara 'product:added'. Por isso quem cede é este,
           e a checagem é
           no clique, não no registro — a ordem de carga entre asset e ScriptTag não é
           determinística. Ver docs/theme-quality/2026-07-27-duplo-add-to-cart.md */
        if (window.__lkQuickAddHotfixV1) return;
        var btn = e.target && e.target.closest && e.target.closest('.pc__quickadd-btn[data-variant-id], .pc__size[data-variant-id], .pc__atc[data-variant-id]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var vid = btn.dataset && btn.dataset.variantId;
        if (!vid) return;
        var origText = btn.textContent;
        btn.textContent = btn.classList.contains('pc__atc') ? 'Adicionando...' : '...';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({id: parseInt(vid, 10), quantity: 1})
        })
        .then(function(r) { if (!r.ok) throw new Error('cart_add_' + r.status); return r.json(); })
        .then(function() {
          btn.textContent = btn.classList.contains('pc__atc') ? '\u2713 Adicionado' : '\u2713';
          btn.classList.add('pc__quickadd-btn--added', 'pc__atc--added');
          /* Refresh the cart drawer (badge + items) and open it \u2014 matches the PDP / canonical add-to-cart flow */
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          document.dispatchEvent(new CustomEvent('lk:pdp-journey', { detail: { stage: 'add_success', variantId: String(vid), source: 'quickadd' } }));
          setTimeout(function() {
            btn.textContent = origText;
            btn.classList.remove('pc__quickadd-btn--added', 'pc__atc--added');
            btn.disabled = false;
          }, 2000);
        })
        .catch(function() {
          btn.textContent = 'Erro';
          btn.disabled = false;
          setTimeout(function() { btn.textContent = origText; }, 1500);
        });
      }, true);
    }, { timeout: 2000 });

/* ── size-sheet (PLP cards with >12 variants) ── */
(function(){
  if (window.__lkSizeSheetV1) return;
  window.__lkSizeSheetV1 = true;
  var openSheet = null;
  var lastTrigger = null;

  function closeSheet() {
    if (!openSheet) return;
    var sheet = openSheet;
    var trigger = lastTrigger;
    openSheet = null;
    lastTrigger = null;
    sheet.classList.remove('is-open');
    sheet.hidden = true;
    document.body.classList.remove('pc-size-sheet-open');
    if (sheet.__lkHome && sheet.parentNode !== sheet.__lkHome) {
      sheet.__lkHome.appendChild(sheet);
    }
    sheet.__lkHome = null;
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      try { trigger.focus(); } catch (e) {}
    }
  }

  function openSheetFor(trigger) {
    var id = trigger.getAttribute('aria-controls');
    var sheet = (id && document.getElementById(id)) || (trigger.closest && trigger.closest('.pc') && trigger.closest('.pc').querySelector('.pc-size-sheet'));
    if (!sheet) return;
    if (openSheet && openSheet !== sheet) closeSheet();
    lastTrigger = trigger;
    openSheet = sheet;
    if (!sheet.__lkHome) sheet.__lkHome = sheet.parentNode;
    if (document.body && sheet.parentNode !== document.body) document.body.appendChild(sheet);
    sheet.hidden = false;
    sheet.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('pc-size-sheet-open');
    var closeBtn = sheet.querySelector('.pc-size-sheet__close');
    if (closeBtn) {
      try { closeBtn.focus(); } catch (e) {}
    }
  }

  document.addEventListener('click', function(e) {
    var target = e.target && e.target.closest ? e.target : null;
    if (!target || !target.closest) return;
    if (target.closest('[data-lk-size-sheet-close]')) {
      e.preventDefault();
      closeSheet();
      return;
    }
    var trigger = target.closest('[data-lk-size-sheet-open]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    if (openSheet && lastTrigger === trigger) closeSheet();
    else openSheetFor(trigger);
  });

  document.addEventListener('keydown', function(e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && openSheet) {
      e.preventDefault();
      closeSheet();
    }
  });

  document.addEventListener('cart:open', closeSheet);
  document.addEventListener('product:added', closeSheet);
})();

/* ── whatsapp-offset (era layout/theme.liquid L1178) ── */
(function(){
      function lkMuteMobileConversionWhatsApp(){
        if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
        var isConversionPage = document.body && (document.body.classList.contains('template-product') || document.body.classList.contains('template-collection'));
        if (!isConversionPage) return;
        var widget = document.getElementById('lk-wa-widget');
        var tooltip = document.getElementById('lk-wa-tooltip');
        if (widget) widget.classList.remove('is-shown');
        if (tooltip) tooltip.style.setProperty('display', 'none', 'important');
      }
      lkMuteMobileConversionWhatsApp();
      window.addEventListener('load', lkMuteMobileConversionWhatsApp);
      setTimeout(lkMuteMobileConversionWhatsApp, 1200);
      setTimeout(lkMuteMobileConversionWhatsApp, 5200);
      setTimeout(lkMuteMobileConversionWhatsApp, 9000);
    })();

